var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"DropdownLinks"},_vm._l((_vm.links),function(item){return _c('AppLink',{key:item.title,staticClass:"DropdownLinks__item",attrs:{"link":item,"title":item.title}},[_vm._v(_vm._s(item.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }